import React from 'react'
import {Outlet} from 'react-router-dom'
import Header from '../components/public/header/index'
import Footer from '../components/public/footer/index'
import { useState } from 'react'
import { ReactComponent as WhatsappIcon} from '../images/icons/whatsapp.svg'
import { ReactComponent as CallIcon} from '../images/icons/call.svg'
import ChatBoxes from '../components/public/others/chatBoxes'

const Public = ({HomeSwitch,SetHomeSwitch,openChatBox,setOpenChatBox}) => {
  const [menuOpen,setMenuOpen] = useState(false);
  const User = JSON.parse(localStorage.getItem("user-info"));
  return (
    <>
        <Header HomeSwitch={HomeSwitch} SetHomeSwitch={SetHomeSwitch} menuOpen={menuOpen} setMenuOpen={setMenuOpen} openChatBox={openChatBox} setOpenChatBox={setOpenChatBox}/>
        <div className='mainBody'>
            <Outlet />
        </div>
        <div className='whatsapp_popup_wrapper'>
          <a href='https://wa.me/923111777566' target={'_blank'}>
              <div className='whatsapp_popup_container' style={{marginBottom:"10px"}}>
                <WhatsappIcon />
              </div>
          </a>
          <a href='tel:+923111777566' target={'_blank'}>
              <div className='whatsapp_popup_container' style={{padding:"10px"}}>
                <CallIcon width={'20px'} height={'20px'}/>
              </div>
          </a>
        </div>
        {User &&
          <ChatBoxes openChatBox={openChatBox} setOpenChatBox={setOpenChatBox}/>
        }
        <Footer setMenuOpen={setMenuOpen} openChatBox={openChatBox} setOpenChatBox={setOpenChatBox}/>
    </>
  )
}

export default Public
